import { render, staticRenderFns } from "./WaterRecord.vue?vue&type=template&id=35ae23fa&scoped=true&"
import script from "./WaterRecord.vue?vue&type=script&lang=js&"
export * from "./WaterRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae23fa",
  null
  
)

export default component.exports